<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row no-gutter justify-center items-center">
                        <div class="vx-col hidden lg:block lg:w-1/2">
                            <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Login</h4>
                                    <p>Welcome back, please login to your account.</p>
                                </div>
                                <vs-input
                                    name="email"
                                    icon="icon icon-user"
                                    icon-pack="feather"
                                    label-placeholder="Email"
                                    v-model="user.email"
                                    class="w-full no-icon-border"/>

                                <vs-input
                                    type="password"
                                    name="password"
                                    icon="icon icon-lock"
                                    icon-pack="feather"
                                    label-placeholder="Password"
                                    v-model="user.password"
                                    class="w-full mt-6 no-icon-border" />

                                <div class="flex flex-wrap justify-between my-5">
                                    <router-link to="/forgot-password">Forgot Password?</router-link>

                                </div>
                                <vs-button  type="border"  @click="registerUser" >Register</vs-button>
                                <vs-button class="float-right" @click="login($vs)">Login</vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import jwt from "jsonwebtoken";

export default {
    data() {
        return {
            user:
            {
                email: '',
                password: '',
            }
        }
    },
    computed: {
        validateForm() {
            return !this.errors.any() && this.email != '' && this.password != '';
        },
    },
    methods: {
        registerUser() {
            this.$router.push('/register');
        },
        login(item) {
            this.$vs.loading()
            axios.post(process.env.VUE_APP_API + "login/", this.user)
            .then(response => {
                this.$vs.loading.close();
                this.$store.commit('SET_LOGIN_STATE');
                var dt = new Date();
				var expTime = dt.setHours(dt.getHours() + 12);
                this.$store.commit('SET_EXPIRE_TIME', expTime);
                this.$store.commit('SAVE_IDTOKEN', response.data.id_token);
                var token = jwt.decode(response.data.id_token);
                this.$store.commit('SAVE_IDMCLAIMS', token.idm_claims);
                this.$store.commit('SAVE_USER_ID', token.sub);     
                this.$router.push('/home');
            })
        .catch(() => {
            this.$vs.loading.close();
            item.notify({
                title: 'Error',
                position: 'top-right',
                text: 'Username or password is incorrect, please try again',
                color: 'danger',
                iconPack: 'feather',
                icon: 'icon-alert-circle'})
            return;
            });
        }
    }
}
</script>